import React, { Component } from 'react';
import "./style.scss";

class BasketContent extends Component {
    render() {
        return (
            <div>
                Basket page in progress !
            </div>
        );
    }
}

export default BasketContent;